<template>
  <div class="Box">
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogTableVisible" width="65%"
               :before-close="handleClose">
      <div class="video_box">

        <div class="left">
          <div id="videoPlayer"></div>
        </div>

        <div class="right">
          <div
              class="btn"
              v-for="(item, index) in videoList"
              :key="index"
              @click="addTab(item, index)"
              :class="{ highlighted: currentEpisodeIndex === index }"
          >
            {{ item.sequence }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {WorksListAPI} from '@/api/Works/WorksList';
import {processErrors} from "@/utils/errorHandler";
import Player from 'xgplayer'
import HlsPlugin from 'xgplayer-hls'

export default {
  props: ['dialogTableVisible', 'videoObj'],
  components: {},
  data() {
    return {
      title: '',
      videoList: [],
      videoUrl: '',
      currentEpisodeIndex: 0, // 当前播放的集数索引
      isValidUrl: null,//视频格式
    };
  },
  computed: {
    currentEpisode() {
      return this.videoList[this.currentEpisodeIndex];
    },
  },
  methods: {
    handleClose() {
      this.$emit('videoNone');
    },
    addTab(item, index) {
      this.currentEpisodeIndex = index;
      if (this.player) {
        this.player.destroy();
      }
      this.videoPlayUrl(item);
    },

    /**
     * 获取播放地址
     */
    videoPlayUrl(item) {
      let api = WorksListAPI();
      api.getPlayUrl({id: item.episodes_id}).then((res) => {
        if (res.code == 0) {
          if (res.data !== '') {
            this.videoUrl = res.data;
            this.checkLink(this.videoUrl).then(isAvailable => { // 使用 then 处理结果
              if (isAvailable) {
                this.isValidUrl = this.checkVideoUrlFormat(this.videoUrl);
                if(this.isValidUrl == 'm3u8'){
                  this.doVideoPlayerHls();
                }else{
                  this.doVideoPlayer();
                }
              } else {
                this.videoUrl = item.resource_uri;
                this.doVideoPlayer();
              }
            });
          } else {
            this.videoUrl = item.resource_uri;
            this.doVideoPlayer();
          }
        } else {
          processErrors(res);
          this.videoUrl = item.resource_uri;
          this.doVideoPlayer();
        }
      });
    },

    /**
     * 检查链接可用性
     */
    checkLink(url) {
      return fetch(url) // 返回一个 Promise
          .then(response => {
            return response.ok; // 返回 true 或 false
          })
          .catch(error => {
            return false; // 如果请求失败，返回 false
          });
    },

    checkVideoUrlFormat(url) {
      // 正则表达式检查视频文件扩展名
      const videoFormatPattern = /\.(mp4|m3u8|avi|mov|wmv|mkv|flv|webm)(\?.*)?$/i; // 修改正则表达式
      const match = url.match(videoFormatPattern); // 使用 match 方法获取匹配结果
      if (match) {
        // 如果匹配成功，返回扩展名（去掉前面的点）
        return match[1]; // 返回格式，例如 "m3u8"
      } else {
        return null; // 如果没有匹配，返回 null
      }
    },

    /**
     * 播放HLS视频
     */
    doVideoPlayerHls() {
      this.player = new Player({
        id: 'videoPlayer',
        url: this.videoUrl, // HLS 视频流地址
        type: 'hls',
        width: '100%',
        height: '100%',
        controls: true,//是否使用控件
        autoplay: true,//是否自动播放
        plugins: [HlsPlugin]
      });

      this.player.on('play', () => {//播放
      });

      this.player.on('pause', () => {//暂停
      });

      this.player.on('ended', () => {//播放完成
        if (this.currentEpisodeIndex < this.videoList.length - 1) {
          this.currentEpisodeIndex += 1;
          this.videoPlayUrl(this.videoList[this.currentEpisodeIndex]);
        } else {
          this.$message({
            message: '已经是最后一集了',
            type: 'warning',
          });
        }
      });

      this.player.on('error', (error) => {
        console.log('播放器错误：', error)
      })
    },

    /**
     * 播放原视频
     */
    doVideoPlayer() {
      // 如果播放器已经存在，先销毁它
      if (this.player) {
        this.player.destroy();
      }

      this.player = new Player({
        id: 'videoPlayer',
        url: this.videoUrl, // HLS 视频流地址
        type: 'hls',
        width: '100%',
        height: '100%',
        controls: true,//是否使用控件
        autoplay: true,//是否自动播放
      });

      this.player.on('play', () => {//播放
      });

      this.player.on('pause', () => {//暂停
      });

      this.player.on('ended', () => {//播放完成
        if (this.currentEpisodeIndex < this.videoList.length - 1) {
          this.currentEpisodeIndex += 1;
          this.videoPlayUrl(this.videoList[this.currentEpisodeIndex]);
        } else {
          this.$message({
            message: '已经是最后一集了',
            type: 'warning',
          });
        }
      });
    }

  },
  created() {
  },
  mounted() {
    this.title =
        '预览 -' +
        ' 剧名：' +
        this.videoObj.name +
        ' - 集数：' +
        this.videoObj.episode_total
    let api = WorksListAPI();
    api.VideoList(this.videoObj.id).then((res) => {
      if (res.code == 0) {
        this.videoList = res.data;
        this.videoPlayUrl(this.videoList[this.currentEpisodeIndex])
      } else {
        processErrors(res);
      }
    });
  },
};
</script>
<style lang="scss" scoped>
@import '~xgplayer/dist/index.min.css';

.video_box {
  width: 100%;
  height: 500px;
  display: flex;

  .left {
    width: 50%;
    height: 500px;
    background-color: black;
    position: relative;
    flex: 1;
    padding: 0px 20px;
  }

  .right {
    width: 50%;
    height: 500px;
    padding: 10px;
    display: flex;
    overflow: auto;
    flex-wrap: wrap;
    // height: fit-content;
    .btn {
      width: 60px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      margin-left: 10px;
      border: 1px solid #ccc;
      margin-top: 10px;
      cursor: pointer;
    }
  }
}

.highlighted {
  background-color: #409eff;
  color: white;
}

.video_btn {
  width: 100%;
  height: 30px;
  background-color: #1e242c;
  position: absolute;
  bottom: 0;
  opacity: 0.5; /* 设置透明度为50% */
}
</style>
